export const exerciseOptions = {
    method: 'GET',
    // url: 'https://exercisedb.p.rapidapi.com',
    url: 'https://exercisedb.p.rapidapi.com/exercises/bodyPart/back',
    headers: {
      'X-RapidAPI-Key': 'c7644ec9c6msh2cb8ca0577f3d9fp10fe0ejsn8cec2380a3d6',
      'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
    }
  };

export const fetchData = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;

}